import React, { useEffect, forwardRef, useRef } from "react";
import { Input } from "antd";
import { TextAreaRef } from "antd/lib/input/TextArea";
import { useSignal } from "@preact/signals-react";
import { isEmpty } from "lodash";
import styles from "./PreviewHistoryListItemSubTitle.module.scss";

export interface PreviewHistoryListItemSubTitleProps {
  isEditing: boolean;
  value: string;
  handleUpdateDesc: (desc: string) => void;
  handleEditing: (isEditing: boolean) => void;
}

export const PreviewHistoryListItemSubTitle = forwardRef(function (
  props: PreviewHistoryListItemSubTitleProps,
  ref: React.ForwardedRef<TextAreaRef>
) {
  const { isEditing, value, handleUpdateDesc, handleEditing } = props;

  const desc = useSignal<string>(value);
  const descSavedRef = useRef<string>(value);

  function onDescChange(e: React.ChangeEvent<HTMLTextAreaElement>) {
    desc.value = e.target.value;
  }

  function onDescPressEnter(e: React.KeyboardEvent<HTMLTextAreaElement>) {
    e.preventDefault();
    e.stopPropagation();
    e.currentTarget.blur();

    handleEditing(false);
  }

  function onDescBlur(e: React.ChangeEvent<HTMLTextAreaElement>) {
    /// 数据为空
    if (isEmpty(desc.value)) {
      desc.value = descSavedRef.current;
      return;
    }
    /// 数据未修改
    if (desc.value === descSavedRef.current) {
      return;
    }
    /// 保存数据到 previewAppList
    handleUpdateDesc(desc.value);
    /// 缓存数据
    descSavedRef.current = desc.value;
  }

  function onTextClick(e: React.MouseEvent<HTMLInputElement | HTMLTextAreaElement | HTMLDivElement>) {
    if (!isEditing) {
      return;
    }
    e.preventDefault();
    e.stopPropagation();
  }

  useEffect(() => {
    desc.value = value;
  }, [value]);

  return (
    <>
      {isEditing ? (
        <Input.TextArea
          ref={ref}
          placeholder="Add a description"
          className={styles.descInput}
          value={desc.value}
          onClick={e => onTextClick(e)}
          onBlur={e => onDescBlur(e)}
          onChange={e => onDescChange(e)}
          onPressEnter={e => onDescPressEnter(e)}
          autoSize={{ minRows: 1, maxRows: 3 }}
        />
      ) : (
        <div className={styles.desc}>{desc.value || "Add a description"}</div>
      )}
    </>
  );
});
